import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=5e3a7fa5&scoped=true"
import script from "./UserSelection.vue?vue&type=script&lang=js"
export * from "./UserSelection.vue?vue&type=script&lang=js"
import style0 from "./UserSelection.vue?vue&type=style&index=0&id=5e3a7fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a7fa5",
  null
  
)

export default component.exports